/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, fromJS, List } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';

const storeDeals = (state, data, dealType) => state.set(dealType, fromJS(data));

function unlinkDeal(state, deletedLink, rightDealType, unlinkOnlyTransport) {
  let newState = state;
  const rightDealId = deletedLink.get(`${rightDealType}Id`);
  const rightProductId = deletedLink.get(`${rightDealType}Product`);
  const linkId = deletedLink.get('id');
  if (rightDealId !== undefined && rightProductId !== undefined && linkId !== undefined) {
    const rightDealIdx = newState.get(rightDealType)
      .findIndex(deal => deal.get('id') == rightDealId);
    const rightDeal = newState.get(rightDealType)
      .find(deal => deal.get('id') == rightDealId);
    if (rightDeal) {
      const rightProducts = rightDeal.get('products');

      if (rightProducts) {
        const rightProductIdx = rightProducts.findIndex((product) =>
          product.get('id') == rightProductId);

        const rightProduct = rightProducts.find((product) =>
          product.get('id') == rightProductId);

        const rightLinks = rightProduct.get(`${rightDealType}Link`);

        if (rightLinks) {
          const linkIdx = rightLinks.findIndex(link => link.get('id') == linkId);
          if (linkIdx >= 0) {
            if (unlinkOnlyTransport) {
              const leftDealType = rightDealType == 'sale' ? 'purchase' : 'sale';
              newState = newState.deleteIn([rightDealType, rightDealIdx,
                'products', rightProductIdx, `${rightDealType}Link`, linkIdx, `${leftDealType}Id`])
                .deleteIn([rightDealType, rightDealIdx,
                  'products', rightProductIdx, `${rightDealType}Link`, linkIdx,
                  `${leftDealType}Product`]);
            } else {
              newState = newState.deleteIn([rightDealType, rightDealIdx,
                'products', rightProductIdx, `${rightDealType}Link`, linkIdx]);
            }
          }
        }
      }
    }
  }
  return newState;
}
function unlinkTransportStore(state, link) {
  let newState = state;
  const transportId = link.get('transport');
  if (transportId !== undefined) {
    const transport = state.get('transport', new List())
      .find(trn => trn.get('id') === transportId);
    if (transport) {
      const transportIdx = state.get('transport', new List())
        .findIndex(trn => trn.get('id') == transportId);
      const linkIdx = transport.get('links', new List())
        .findIndex(l => l.get('id') == link.get('id'));
      if (linkIdx >= 0) {
        newState = state.deleteIn(['transport', transportIdx, 'links', linkIdx]);
      }
    }
  }
  return newState;
}

// Delete links in  referenced deals after deleting deal
function deleteLinks(state, id, leftDealType) {
  let newState = state;

  const rightDealType = leftDealType == 'sale' ? 'purchase' : 'sale';

  const leftDeal = newState.get(leftDealType)
    .find(deal => deal.get('id') == id);

  const leftProducts = leftDeal.get('products');

  leftProducts.forEach((leftProduct) => {
    const leftLinks = leftProduct.get(`${leftDealType}Link`);

    leftLinks.forEach((leftLink) => {
      const rightDealId = leftLink.get(`${rightDealType}Id`);
      const rightProductId = leftLink.get(`${rightDealType}Product`);

      // берем связанную сделку для апдейта списка линков
      if (rightDealId || rightDealId === 0) {
        const rightDealIdx = newState.get(rightDealType)
          .findIndex(deal => deal.get('id') == rightDealId);

        const rightDeal = newState.get(rightDealType)
          .find(deal => deal.get('id') == rightDealId);

        const rightProducts = rightDeal.get('products');

        const rightProductIdx = rightProducts.findIndex((product) =>
          product.get('id') == rightProductId);

        let rightProduct = rightProducts.find((product) =>
          product.get('id') == rightProductId);

        let rightLinks = rightProduct.get(`${rightDealType}Link`);

        const rightLink = rightLinks.find((link) =>
          link.get('id') == leftLink.get('id'));

        // нашли ссылку, удаляем и обновляем стор
        if (rightLink) {
          rightLinks = rightLinks.filter((link) => link.get('id') !== rightLink.get('id'));
          rightProduct = rightProduct.set(`${rightDealType}Link`, rightLinks);

          newState = newState.setIn([rightDealType, rightDealIdx,
            'products', rightProductIdx], rightProduct);
        }
      }
    });
  });
  return newState;
}

// Updating changed links in opposite deals
function updateLinks(state,
  data,
  leftDealType,
  deletedLinks = new List(),
  unlinkedDealLinks = new List(),
  unlinkedTransportLinks = new List()) {
  let newState = state;

  const rightDealType = leftDealType == 'sale' ? 'purchase' : 'sale';

  unlinkedDealLinks.forEach(unlinkedDealLink => {
    newState = unlinkDeal(newState, unlinkedDealLink, rightDealType, true);
  });
  unlinkedTransportLinks.forEach(unlinkedTransportLink => {
    newState = unlinkTransportStore(newState, unlinkedTransportLink);
  });

  const leftDeal = fromJS(data);
  const leftProducts = leftDeal.get('products');

  deletedLinks.forEach(deletedLink => {
    newState = unlinkTransportStore(newState, deletedLink);
    newState = unlinkDeal(newState, deletedLink, rightDealType, true);
  });

  leftProducts.forEach((leftProduct) => {
    const leftLinks = leftProduct.get(`${leftDealType}Link`);
    leftLinks.forEach((leftLink) => {
      const transportId = leftLink.get('transport');
      if (transportId !== undefined) {
        const transport = newState.get('transport', new List())
          .find(trn => trn.get('id') === transportId);
        if (transport) {
          const transportIdx = newState.get('transport', new List())
            .findIndex(trn => trn.get('id') == transportId);
          const linkIdx = transport.get('links', new List())
            .findIndex(link => link.get('id') == leftLink.get('id'));
          if (linkIdx >= 0) {
            newState = newState.setIn(['transport', transportIdx, 'links', linkIdx, leftLink]);
          } else {
            let links = transport.get('links', new List());
            links = links.push(leftLink);
            newState = newState.setIn(['transport', transportIdx, 'links'], links);
          }
        }
      }

      const rightDealId = leftLink.get(`${rightDealType}Id`);
      const rightProductId = leftLink.get(`${rightDealType}Product`);

      // берем связанную сделку для апдейта списка линков
      if (rightDealId || rightDealId === 0) {
        const rightDealIdx = newState.get(rightDealType)
          .findIndex(deal => deal.get('id') == rightDealId);

        const rightDeal = newState.get(rightDealType)
          .find(deal => deal.get('id') == rightDealId);

        if (rightDeal) {
          const rightProducts = rightDeal.get('products');

          if (rightProducts) {
            const rightProductIdx = rightProducts.findIndex((product) =>
              product.get('id') == rightProductId);

            let rightProduct = rightProducts.find((product) =>
              product.get('id') == rightProductId);

            let rightLinks = rightProduct.get(`${rightDealType}Link`);

            const rightLink = rightLinks.find((link) =>
              link.get('id') == leftLink.get('id'));

            // нашли новую ссылку, добавляем и обновляем стор
            if (!rightLink) {
              rightLinks = rightLinks.push(leftLink);
              rightProduct = rightProduct.set(`${rightDealType}Link`, rightLinks);
              newState = newState
                .setIn([rightDealType, rightDealIdx, 'products', rightProductIdx], rightProduct);
            } else {
              const rightLinkIdx = rightLinks.findIndex((link) =>
                link.get('id') == leftLink.get('id'));
              newState = newState.setIn([rightDealType, rightDealIdx,
                'products', rightProductIdx, `${rightDealType}Link`, rightLinkIdx], leftLink);
            }
          }
        }
      }
    });
  });
  return newState;
}

function updateLinksInDealList(state, dealList, dealType, link) {
  let newState = state;
  if (dealList && link.get(`${dealType}Id`)) {
    const dealIdx = dealList.findIndex(pur => pur.get('id') === link.get(`${dealType}Id`));
    if (dealIdx === -1) {
      return newState;
    }
    const productIdx = dealList.getIn([dealIdx, 'products'])
      .findIndex(prod => prod.get('id') === link.get(`${dealType}Product`));
    if (productIdx === -1) {
      return newState;
    }
    const linkIdx = dealList.getIn([dealIdx, 'products', productIdx])
      .get(`${dealType}Link`).findIndex(purLink => purLink.get('id') === link.get('id'));
    if (linkIdx === -1) {
      return newState;
    }
    newState = newState.setIn(
      [dealType, dealIdx, 'products', productIdx, `${dealType}Link`, linkIdx],
      link);
  }
  return newState;
}

function updateTransportLinks(state, data) {
  let newState = state;
  const purchaseList = newState.get('purchase');
  const saleList = newState.get('sale');
  if (data.get('links')) {
    data.get('links').forEach(link => {
      newState = updateLinksInDealList(newState, purchaseList, 'purchase', link);
      newState = updateLinksInDealList(newState, saleList, 'sale', link);
    });
  }
  return newState;
}
function deleteTransportFromLinks(state, transportId) {
  if (!state.get('transport')) {
    return state;
  }
  let newState = state;
  const purchaseList = newState.get('purchase');
  const saleList = newState.get('sale');
  const transport = newState.get('transport').find(tr => tr.get('id') == transportId);
  if (transport) {
    const links = transport.get('links', new List());
    links.forEach(link => {
      newState = updateLinksInDealList(newState, purchaseList, 'purchase',
        link.set('transport', null).set('billLandingQuantity', null));
      newState = updateLinksInDealList(newState, saleList, 'sale',
        link.set('transport', null).set('billLandingQuantity', null));
    });
  }
  return newState;
}

const dealWebsocketDeleted = (state, id, dealType) => {
  if (state.get(dealType)) {
    if (dealType == 'transport') {
      const transportUnlinkedState = deleteTransportFromLinks(state, id);
      if (!transportUnlinkedState.get(dealType)) {
        return state;
      }
      return transportUnlinkedState.set(dealType,
        transportUnlinkedState.get(dealType).filter(deal => deal.get('id') != id));
    }
    return deleteLinks(state, id, dealType)
      .set(dealType,
        state.get(dealType).filter(deal => deal.get('id') != id));
  }
  return state;
};

const storeFilters = (state, type, filters, fpc) => state.setIn(['filters', type], filters)
  .setIn(['filterPanelCollapsed', type], fpc);
const resetFilters = (state, type) => state.setIn(['filters', type], new Map())
  .setIn(['filterPanelCollapsed', type], false);

const dealWebsocketSaved = (state, data, dealType) => {
  const newData = data;
  newData.recieveThroughWebsocket = true;
  if (state.get(dealType)) {
    const dealItem = state.get(dealType, List()).find(deal => deal.get('id') == newData.id);
    if (!dealItem) {
      if (dealType == 'transport') {
        return state.set(dealType, state.get(dealType).insert(0, fromJS(newData)));
      }
      return updateLinks(state, newData, dealType).set(dealType,
        state.get(dealType).insert(0, fromJS(newData)));
    }
  }
  return state;
};

const clearRecieveThroughWebsocket = (state, id, dealType) => {
  const dealIdx = state.get(dealType, List()).findIndex(d => d.get('id') == id);
  if (dealIdx >= 0) {
    const deal = state.get(dealType, List()).get(dealIdx).delete('recieveThroughWebsocket');
    return state.set(dealType, state.get(dealType).delete(dealIdx).insert(0, deal));
  }
  return state;
};

const dealUpdated = (state, data, dealType, deletedLinks, unlinkedDeals, unlinkedTransports) => {
  if (state.get(dealType)) {
    if (dealType == 'transport') {
      const idx = state.get(dealType).findIndex(deal => deal.get('id') == data.id);
      return updateTransportLinks(state.setIn([dealType, idx], fromJS(data)), fromJS(data));
    }
    const idx = state.get(dealType).findIndex(deal => deal.get('id') == data.id);
    return updateLinks(state, data, dealType, deletedLinks, unlinkedDeals, unlinkedTransports)
      .setIn([dealType, idx], fromJS(data));
  } return state;
};

const eventUpdated = (state, data) =>
  state.map(dealType => dealType.map(deal => (deal.get('calendarEvents') ?
    deal.set('calendarEvents',
      deal.get('calendarEvents').map(event =>
        (event.get('id') == data.id ? fromJS(data) : event)))
    : deal
  )));


const eventDeleted = (state, id) =>
  state.map(dealType => dealType.map(deal => (deal.get('calendarEvents') ?
    deal.set('calendarEvents',
      deal.get('calendarEvents').map(event => (event.get('id') == id ? null : event))
        .filter(event => event != null))
    : deal
  )));

/* eslint-disable no-param-reassign */
const dealWebsocketUpdate = (state, data, dealType) => {
  const deletedLinks =
    data.deletedLinks ? fromJS(data.deletedLinks) : undefined;
  const unlinkedTransports =
    data.unlinkedTransportLinks ? fromJS(data.unlinkedTransportLinks) : undefined;
  const unlinkedDeals =
    data.deletedLinks ? fromJS(data.deletedLinks) : undefined;

  delete data.deletedLinks;
  delete data.unlinkedTransportLinks;

  return dealUpdated(state,
    data,
    dealType,
    deletedLinks,
    unlinkedDeals,
    unlinkedTransports);
};

export const dealsListReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'DEALS_LOADED':
      return storeDeals(state, action.data, action.dealType);

    case 'FILTERS_SET':
      return storeFilters(state, action.dealType, action.filters, action.fpc);
    case 'FILTERS_CLEARED':
      return resetFilters(state, action.dealType);
    case 'EVENT_UPDATED_SUCCESSFULLY':
      return eventUpdated(state, action.data);
    case 'EVENT_DELETED':
      return eventDeleted(state, action.id);

    // для обработки сообщений с websocket'a
    case 'WS_RECEIVED_DEAL_CREATED':
      return dealWebsocketSaved(state, action.data, action.dealType);
    case 'WS_RECEIVED_DEAL_UPDATED':
      return dealWebsocketUpdate(state, action.data, action.dealType);
    case 'WS_RECEIVED_DEAL_DELETED':
      return dealWebsocketDeleted(state, action.id, action.dealType);
    case 'CLEAR_WS_DEAL_DATA':
      return clearRecieveThroughWebsocket(state, action.id, action.dealType);
    default:
      return state;
  }
};

export const clearFilters = (dispatch, dealType) => {
  dispatch({ type: 'FILTERS_CLEARED', dealType });
};

export const clearWsData = (dispatch, id, dealType) => {
  dispatch({ type: 'CLEAR_WS_DEAL_DATA', id, dealType });
};

export const addFilters = (dispatch, dealType, filters, fpc) => {
  dispatch({ type: 'FILTERS_SET', dealType, filters, fpc });
};

export const dealsLoaded = (dispatch, deals, dealType) =>
  dispatch({ type: 'DEALS_LOADED', data: deals, dealType });

export const loadDealsList = (dispatch, type) => {
  markStoreLoading(dispatch, type);
  dispatch({ type: 'LOADING_DEALS' });
  return RestAPI.get(`/deals/${type}/api/`)
    .then(
      (data) => {
        markStoreLoaded(dispatch, type);
        dealsLoaded(dispatch, data, type);
        return true;
      }
    ).catch(
      (data) => {
        putError(dispatch, data);
        markStoreLoaded(dispatch, type);
        dispatch({ type: 'DEALS_LOADING_FAILED' });
        return true;
      }
    );
};
